import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Select } from 'antd';

const { Option } = Select;

const recursive = (accumilator, depth, array) => {
  array.forEach((entry) => {
    if (entry.relations && entry.relations.length) {
      const { relations, ...rest } = entry;
      accumilator.push({ ...rest, depth });
      accumilator = [...accumilator, ...recursive([], depth + 1, entry.relations)];
    } else {
      accumilator.push({ ...entry, depth });
    }
  });
  return accumilator;
};

class NestedSelectWidget extends Component {
  render() {
    return (
      <Select
        defaultValue={0}
        allowClear
        placeholder={this.props.value ? `${this.props.schema.alias}` : 'Ангилал сонгох'}
        value={this.props.value}
        required={this.props.required}
        disabled={this.props.disabled}
        onChange={value => this.props.onChange(value)}
      >
        {recursive([{
          alias: "Үндсэн ангилал",
          id: 0,
          depth: 0,
          relation_id: null,
        }], 0, this.props.schema.options || []).map(({ id, alias, depth }, i) => (
          <Option key={i} value={id}>
            {
              Array(...Array(depth)).map(() => (
                '-'
              ))
            }
            {alias}
          </Option>
        ))}
      </Select>
    );
  }
}

NestedSelectWidget.defaultProps = {
  value: undefined,
  // placeholder: '',
  options: {},
  // formContext: {},
  disabled: false,
};

NestedSelectWidget.propTypes = {
  value: PropTypes.any,
  required: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  schema: PropTypes.object.isRequired,
  // placeholder: PropTypes.string,
  options: PropTypes.object,
  // formContext: PropTypes.object,
  disabled: PropTypes.bool,
};

export default NestedSelectWidget;



// WEBPACK FOOTER //
// ./src/components/Form/Widgets/NestedSelectWidget/index.js